import { SET_ACTIVE_USER_ID } from 'redux/actionTypes';

export default function activeUserId(state= "", action) {
    switch(action.type){
        case SET_ACTIVE_USER_ID:
            return action.payload;
        default:
            return state;
    }
};